import React from "react";
import { ValueOrPlaceholder } from "@sscs/ui";
import { isCopyleftLicense } from "../../../utils";
import { parseIdentityLicense } from "../../utils";
import { CopyleftIcon, LinkToReportTab } from "../index";
import styles from "./license.module.scss";
const License = ({ id, license, to, onClick, }) => {
    if (!license) {
        return React.createElement(ValueOrPlaceholder, { value: license });
    }
    const parsedLicense = parseIdentityLicense(license);
    return (React.createElement("div", { className: styles.copyleft },
        isCopyleftLicense(license) && React.createElement(CopyleftIcon, null),
        React.createElement("div", null,
            React.createElement(LinkToReportTab, { id: id, to: to, color: "link", className: styles.link, onClick: onClick }, parsedLicense === null || parsedLicense === void 0 ? void 0 : parsedLicense.family),
            React.createElement("span", null,
                "\u00A0", parsedLicense === null || parsedLicense === void 0 ? void 0 :
                parsedLicense.rest))));
};
export default License;
//# sourceMappingURL=License.js.map